<template>
  <div class="label-container">
    <div class="sub-title-container">
      {{ labelText }}
    </div>
    <icon-default
        :color="'light-purple'"
        :size="'mini'"
        @click="$emit('closeLabel')">
      <IconCross/>
    </icon-default>
  </div>
</template>

<script>
import IconDefault from "@/components/shared/icons/IconDefault.vue";
import IconCross from "@/assets/icons/ui/cross.svg?inline";

export default {
  name: "LabelCustom",
  components: {IconDefault, IconCross},
  props: {
    labelText: {
      type: String,
      required: true
    }
  },
}
</script>

<style scoped lang="scss">
  .label-container {
    width: fit-content;
    border-radius: 8px;
    padding: 0 0 0 8px;
    display: flex;
    flex-direction: row;
    column-gap: 8px;
    align-items: center;
    background: rgba(207, 215, 209, 0.3);

    .sub-title-container {
      color: var(--color-dark-green);
      font-size: 16px;
    }

    .icon-container {
      cursor: pointer;
      padding: 4px;
    }

  }
</style>